// Textos de la zona "pip" (panel flotante). Claves con prefijo "pip.".
const en = {
  'pip.btn.open': 'FLOATING PANEL',
  'pip.btn.close': 'CLOSE PANEL',
  'pip.btn.openTitle': 'Opens an always-on-top floating panel to control the master from another tab',
  'pip.btn.closeTitle': 'Closes the floating panel',
  'pip.error.open': 'Could not open the floating panel. Press the button again.',

  'pip.name': 'MASTER',
  'pip.dim.onTitle': 'Dim mode on: the panel fades when you are not using it. Press to turn it off.',
  'pip.dim.offTitle': 'Dim mode: fades the panel when you are not using it, so it stays out of the way.',
  'pip.capture.on': 'Capture active',
  'pip.capture.off': 'No capture',
  'pip.reset.title': 'Back to the original level (100 %)',

  'pip.sw.mute': 'MUTE',
  'pip.sw.muteTitle': 'Mutes the output',
  'pip.sw.bypass': 'BYPASS',
  'pip.sw.bypassTitle': 'Turns off every effect in the rack and leaves the natural signal',
  'pip.sw.max': 'MAX {n}',
  'pip.sw.limitLabel': 'Fader limit',
  'pip.sw.limitOnTitle': 'Fader up to 600 %. Above 100 % you can damage your ears or your speakers.',
  'pip.sw.limitOffTitle': 'Fader limited to the original level (100 %). Press to boost up to 600 %.',

  'pip.status.noCapture': 'No active capture.',
  'pip.status.muted': 'Muted: no audio out.',
  'pip.status.danger': 'Dangerous level.',
  'pip.status.over': 'Above the original level.',
  'pip.status.bypass': 'Natural signal, no effects.',
  'pip.status.processing': 'Processing.',

  'pip.zone.danger': 'DANGEROUS',
  'pip.zone.boosted': 'BOOSTED',
  'pip.zone.original': 'ORIGINAL',
  'pip.zone.normal': 'NORMAL',

  'pip.slider.label': 'Master volume',
  'pip.slider.valueText': '{value} percent, {zone}',

  'pip.meter.muted': 'Output level: muted by Mute, no signal out.',
  'pip.meter.active': 'Master output level, left (L) and right (R) channels, measured after the fader. The mark is the peak; the top LED warns when the signal hits the ceiling.',
  'pip.meter.idle': 'Master output level. Without capture there is nothing to measure.',

  'pip.configs.title': 'PRESETS',
  'pip.configs.empty': 'Save a preset in DragonAudio and it will show up here.',
  'pip.configs.applied': '"{name}" is applied',
  'pip.configs.apply': 'Apply "{name}"',
  'pip.configs.factory': 'Templates',
  'pip.configs.mine': 'My effects',
  'pip.configs.none': 'No preset loaded',
  'pip.configs.prev': 'Previous preset',
  'pip.configs.next': 'Next preset',
  'pip.configs.expand': 'Show {name}',
  'pip.configs.collapse': 'Hide {name}',
  'pip.configs.dry': 'Clean',
  'pip.configs.muted': 'This preset mutes the master',
  'pip.configs.volume': 'Sets the master to {v} %',
  'pip.configs.bypassed': 'Saved with effects bypassed',
  'pip.configs.size': 'Text size: {name} (click to change)',
  'pip.configs.sizeN': 'normal',
  'pip.configs.sizeL': 'large',
  'pip.configs.sizeXL': 'extra large',

  'pip.keys.title': 'KEYBOARD SHORTCUTS',
  'pip.keys.btnTitle': 'Keyboard shortcuts (?)',
  'pip.keys.close': 'Close',
  'pip.keys.hint': 'Press for keyboard shortcuts',
  'pip.keys.volume': 'Volume up / down (5 by 5)',
  'pip.keys.volumeFine': 'Fine volume (1 by 1)',
  'pip.keys.preset': 'Previous / next preset',
  'pip.keys.mute': 'Mute the master',
  'pip.keys.bypass': 'Bypass effects',
  'pip.keys.reset': 'Volume back to 100',
  'pip.keys.limit': 'Limit 100 ↔ 600 (amplification)',
  'pip.keys.help': 'Show / hide this sheet',
  'pip.keys.focus': 'Shortcuts work while the floating panel has focus: click on it first.',
  'pip.keys.noPresets': 'NO PRESETS',
};

const es = {
  'pip.btn.open': 'PANEL FLOTANTE',
  'pip.btn.close': 'CERRAR PANEL',
  'pip.btn.openTitle': 'Abre un panel flotante siempre encima para controlar el master desde otra pestaña',
  'pip.btn.closeTitle': 'Cierra el panel flotante',
  'pip.error.open': 'No se pudo abrir el panel flotante. Vuelve a pulsar el botón.',

  'pip.name': 'MASTER',
  'pip.dim.onTitle': 'Modo tenue activo: el panel se atenúa cuando no lo usas. Pulsa para desactivarlo.',
  'pip.dim.offTitle': 'Modo tenue: atenúa el panel cuando no lo usas, para que no moleste.',
  'pip.capture.on': 'Captura activa',
  'pip.capture.off': 'Sin captura',
  'pip.reset.title': 'Volver al nivel original (100 %)',

  'pip.sw.mute': 'MUTE',
  'pip.sw.muteTitle': 'Silencia la salida',
  'pip.sw.bypass': 'BYPASS',
  'pip.sw.bypassTitle': 'Apaga todos los efectos del rack y deja la señal natural',
  'pip.sw.max': 'MÁX {n}',
  'pip.sw.limitLabel': 'Límite del fader',
  'pip.sw.limitOnTitle': 'Fader hasta el 600 %. Por encima del 100 % puedes dañar tus oídos o tus parlantes.',
  'pip.sw.limitOffTitle': 'Fader limitado al nivel original (100 %). Pulsa para amplificar hasta el 600 %.',

  'pip.status.noCapture': 'Sin captura activa.',
  'pip.status.muted': 'Silenciado: no sale audio.',
  'pip.status.danger': 'Nivel peligroso.',
  'pip.status.over': 'Sobre el nivel original.',
  'pip.status.bypass': 'Señal natural, sin efectos.',
  'pip.status.processing': 'Procesando.',

  'pip.zone.danger': 'PELIGROSO',
  'pip.zone.boosted': 'AMPLIFICADO',
  'pip.zone.original': 'ORIGINAL',
  'pip.zone.normal': 'NORMAL',

  'pip.slider.label': 'Volumen master',
  'pip.slider.valueText': '{value} por ciento, {zone}',

  'pip.meter.muted': 'Nivel de salida: silenciado por el Mute, no sale señal.',
  'pip.meter.active': 'Nivel de salida del master, canales izquierdo (L) y derecho (R), medido después del fader. La marca es el pico; el LED de arriba avisa cuando la señal está pegada al techo.',
  'pip.meter.idle': 'Nivel de salida del master. Sin captura no hay nada que medir.',

  'pip.configs.title': 'CONFIGURACIONES',
  'pip.configs.empty': 'Guarda una configuración en DragonAudio y aparecerá aquí.',
  'pip.configs.applied': '"{name}" está aplicada',
  'pip.configs.apply': 'Aplicar "{name}"',
  'pip.configs.factory': 'Plantillas',
  'pip.configs.mine': 'Mis efectos',
  'pip.configs.none': 'Sin preset cargado',
  'pip.configs.prev': 'Preset anterior',
  'pip.configs.next': 'Preset siguiente',
  'pip.configs.expand': 'Mostrar {name}',
  'pip.configs.collapse': 'Ocultar {name}',
  'pip.configs.dry': 'Limpio',
  'pip.configs.muted': 'Este preset silencia el master',
  'pip.configs.volume': 'Pone el master al {v} %',
  'pip.configs.bypassed': 'Guardado con los efectos en bypass',
  'pip.configs.size': 'Tamaño de letra: {name} (pulsa para cambiar)',
  'pip.configs.sizeN': 'normal',
  'pip.configs.sizeL': 'grande',
  'pip.configs.sizeXL': 'enorme',

  'pip.keys.title': 'ATAJOS DE TECLADO',
  'pip.keys.btnTitle': 'Atajos de teclado (?)',
  'pip.keys.close': 'Cerrar',
  'pip.keys.hint': 'Pulsa para ver los atajos de teclado',
  'pip.keys.volume': 'Subir / bajar volumen (de 5 en 5)',
  'pip.keys.volumeFine': 'Volumen fino (de 1 en 1)',
  'pip.keys.preset': 'Preset anterior / siguiente',
  'pip.keys.mute': 'Silenciar el master',
  'pip.keys.bypass': 'Bypass de efectos',
  'pip.keys.reset': 'Volumen de vuelta a 100',
  'pip.keys.limit': 'Límite 100 ↔ 600 (amplificación)',
  'pip.keys.help': 'Mostrar / ocultar esta hoja',
  'pip.keys.focus': 'Los atajos funcionan con el panel flotante enfocado: haz clic en él primero.',
  'pip.keys.noPresets': 'SIN PRESETS',
};

const pip = { en, es };
export default pip;
